import React from 'react';
import useAllRTMPlan from './useAllRTMPlan';

const useGetAllRTMPlan = ({ pageNumber, perpageData,frequency,status,billingCycle,search = "",sort,order}: { pageNumber: number; perpageData: number; frequency:string;status:string;billingCycle:string;search?: string,sort: string,order?: 'asc' | 'desc' }) => {
  const { RTMPlanData, getRTMPlanData, RTMPlanDataLoading } = useAllRTMPlan({ pageNumber, perpageData, frequency,status,billingCycle,search,sort,order});

  React.useEffect(() => {
    getRTMPlanData();
    // eslint-disable-next-line
  }, [pageNumber, search,status,frequency,billingCycle,sort,order]);

  return {
    RTMPlanData,
    getRTMPlanData,
    RTMPlanDataLoading,
  };
};

export default useGetAllRTMPlan;
